<template>
  <div>
    <div class="bg-slightGrey width-100 padding-90 container">
      <div
        class="list br-mid bg-white width-100 margin-b flex-row justify-content-spaceBetween align-items-star"
        v-for="(item, index) in signList"
        :key="index"
      >
        <div class="width-75">
          <p class="info fs-mid" style="color: rgb(182, 29, 21)"><span class="">预约时间</span> {{ item.signDate }}</p>
          <p class="info"><span class="">预约人</span> {{ item.signUsername }}</p>
          <p class="info"><span class="">时间段</span> {{ item.timeslot.startTime + '-' + item.timeslot.endTime }}</p>
        </div>

        <div class="width-25 flex-column justify-content-spaceBetween">
          <div class="width-100">
            <van-button
              v-if="item.signAuthStatus === '0' || item.signAuthStatus === '1'"
              @click="toQRCode(item)"
              type="primary"
              class="width-100 button"
              :disabled="item.signAuthStatus === '1'"
              size="mini"
              color="linear-gradient(to bottom,rgb(182, 29, 21), rgb(194, 30, 21))"
              >{{ item.signAuthStatus === '1' ? '已核销' : '去核销' }}</van-button
            >
          </div>
          <div v-if="item.signAuthStatus === '0'" class="width-100 margin-t">
            <van-button
              @click="cancelSign(item)"
              type="primary"
              class="width-100 button"
              size="mini"
              color="linear-gradient(to bottom,rgb(182, 29, 21), rgb(194, 30, 21))"
              >取消预约</van-button
            >
          </div>
          <div v-if="item.signAuthStatus === '2'" class="width-100 margin-t">
            <van-button
              type="primary"
              class="width-100 button"
              disabled
              size="mini"
              color="linear-gradient(to bottom,rgb(182, 29, 21), rgb(194, 30, 21))"
              >已取消</van-button
            >
          </div>
        </div>
      </div>
      <van-empty v-if="signList.length <= 0" description="无预约记录" />
    </div>
    <div class="width-100 fixed" style="">
      <img @click="$router.push('/index')" src="@/assets/image/signButton.png" style="width: 100%" />
    </div>
    <van-popup v-model="signPopup" style="height: 400px; border-radius: 15px" class="flex-column align-items-center justify-content-center width-90">
      <img src="@/assets/image/popup.png" width="100%" alt="" style="height: 400px" />
      <div class="position-absolute zIndex textAlign-c width-100" style="top: 300px">
        <van-button @click="signPopup = false" type="danger" style="border-radius: 8px; width: 80%">确定</van-button>
      </div>
    </van-popup>
  </div>
</template>
<script>
import signApi from '@/api/signApi';
import { Dialog, Notify } from 'vant';

export default {
  components: {},
  name: 'myAppointed',
  data() {
    return {
      // 微信OpenId
      openId: null,
      // 预约列表
      signList: [],
      // 预约提示弹窗
      signPopup: false
    };
  },
  mounted() {
    const env = this.$store.state.env;
    if (env === 'raxw') {
      // 瑞安新闻登录
      signApi.list({ wxId: 'raxw_' + this.$store.state.raxwUser.account_id }).then((res) => {
        this.signList = res.data;
      });
    }
    if (env === 'wx') {
      // 微信已登录
      signApi.list({ wxId: this.$store.state.openId }).then((res) => {
        this.signList = res.data;
      });
    }
  },
  methods: {
    // 跳转至核销页面
    toQRCode(item) {
      if (item.signAuthStatus !== '1')
        this.$router.push({
          path: '/QRCode',
          query: {
            signId: item.id
          }
        });
    },
    // 取消预约
    cancelSign(item) {
      Dialog.confirm({
        title: '取消预约',
        message: '您确认要取消该次预约吗？'
      })
        .then(() => {
          item.signAuthStatus = '2';
          signApi.save(item).then((res) => {
            if (res.code === 200) {
              Notify({
                type: 'success',
                message: '取消预约成功'
              });
            } else {
              Notify({
                type: 'danger',
                message: '取消预约失败，请联系管理员'
              });
            }
          });
        })
        .catch(() => {
          Notify({
            type: 'danger',
            message: '网络错误，请稍后再试'
          });
        });
    }
  }
};
</script>

<style lang="less" scoped>
.button {
  box-shadow: 0 5px 2px rgba(0, 0, 0, 0.05);
}
.list {
  padding: 20px 5% 10px;
}
.info {
  margin-bottom: 10px;
  color: #333333;
  span {
    display: inline-block;
    width: 28%;
    color: #999999;
  }
}
/deep/.van-button--disabled {
  background: #999999 !important;
}
.container {
  padding-bottom: 80px;
  overflow-y: scroll;
  height: 100vh;
}
.fixed {
  padding: 10px 10% 0 10%;
  position: fixed;
  bottom: 0px;
  //background-color: #ffffff;
  border-radius: 10px 10px 0 0;
}
</style>
